<t-greeting-card title="Access Denied" description="">
  <p description class="text-sm text-white">
    You have not been given access. Please contact us if you think this is an error or try with a
    <span (click)="loginWithRedirect()" class="cursor-pointer underline">different account</span>.
  </p>
</t-greeting-card>
